import { ReactElement } from 'react';
import ModalImg from 'src/assets/images/create-menu-item-modal.png';
import { Modal } from '@weareopenr/component-library';
import PriceBandRuleModalContent from './PriceBandRuleModalContent';
import { useVenues } from 'src/hooks/useVenues/useVenues';
import { IPriceBandWithVenues } from 'src/types/priceBand.types';
import { IPriceRule } from 'src/types/price.types';
import { usePriceScheme } from 'src/hooks/usePriceScheme';

type TPriceBandAndRules = IPriceBandWithVenues & IPriceRule;

type PriceBandRuleModalProps = {
  closeModal: () => void;
  open: boolean;
  step?: number;
  priceSchemeId: string;
  priceBandToEdit?: TPriceBandAndRules;
  priceBands: IPriceBandWithVenues[];
};

export const PriceBandRuleModal = ({
  closeModal,
  open,
  priceSchemeId,
  priceBands = [],
  priceBandToEdit,
  step,
}: PriceBandRuleModalProps): ReactElement => {
  const { data: venues = [] } = useVenues();
  const { data: priceScheme } = usePriceScheme(priceSchemeId);

  const priceSchemeName = priceScheme?.name ?? '';
  const priceBandVenues: [string, string[]][] = priceBands.map((band) => [
    band.name,
    band.venues?.map(({ venueId }) => venueId) ?? [],
  ]);

  const venuesWithPriceBandName = venues.map((v) => ({
    ...v,
    price_band_name: priceBandVenues.find((pbv) => pbv.at(1).includes(v.venue_id))?.[0],
  }));

  return (
    <Modal closeModal={closeModal} open={open} image={ModalImg} imageAlt="Picture of ingredient">
      <PriceBandRuleModalContent
        priceBands={priceBands}
        priceBandToEdit={priceBandToEdit}
        priceSchemeId={priceSchemeId}
        priceSchemeName={priceSchemeName}
        defaultStep={step}
        closeModal={closeModal}
        venues={venuesWithPriceBandName}
      />
    </Modal>
  );
};
